import { Box, Text, VStack } from '@chakra-ui/react'
import { FieldMapValue, SoapNoteData } from '@hb/shared'

const FIELD_LABELS: Record<keyof SoapNoteData, string> = {
  subjective: 'Subjective (S)',
  objective: 'Objective (O)',
  assessment: 'Assessment (A)',
  plan: 'Plan (P)',
}

const FIELD_ORDER: (keyof SoapNoteData)[] = ['subjective', 'objective', 'assessment', 'plan']

export const SoapNoteView = ({ data }: { data: FieldMapValue }) => {
  const soapNote = data?.soapNote as SoapNoteData | undefined

  if (!soapNote) {
    return (
      <Text fontSize="sm" fontStyle="italic" color="gray.400">
        No SOAP note documented.
      </Text>
    )
  }

  return (
    <VStack align="stretch" spacing={3} w="100%">
      {FIELD_ORDER.map(key => (
        <Box key={key}>
          <Text fontSize="xs" fontWeight={600} color="gray.500" mb={0.5}>
            {FIELD_LABELS[key]}
          </Text>
          {soapNote[key] ? (
            <Text fontSize="sm" whiteSpace="pre-wrap">
              {soapNote[key]}
            </Text>
          ) : (
            <Text fontSize="sm" fontStyle="italic" color="gray.400">
              Not recorded
            </Text>
          )}
        </Box>
      ))}
    </VStack>
  )
}
